import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import { MapPin, Phone, ArrowRight, MessageSquare } from 'lucide-react';

const Thankyou = () => {
  const primaryGradient = "linear-gradient(90deg, #6366f1 0%, #a855f7 100%)";
  const phoneNumber = "+971 58 824 3660";
  const whatsappLink = "https://wa.me/971588243660";

  return (
    <div className="min-h-screen bg-[#020617] text-white flex flex-col items-center justify-center p-6 font-sans relative overflow-hidden">
      
      {/* Background Glow */}
      <div className="absolute top-1/4 left-1/2 -translate-x-1/2 w-[600px] h-[600px] bg-purple-900/10 rounded-full blur-[130px] pointer-events-none" />

      <motion.div 
        initial={{ opacity: 0, scale: 0.95 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.5 }}
        className="z-10 max-w-4xl w-full text-center"
      >
        {/* TOP BADGE */}
        <div className="inline-flex items-center gap-2 px-5 py-2 rounded-full border border-white/5 bg-white/5 mb-10">
          <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse" />
          <span className="text-[10px] uppercase tracking-[0.3em] font-black text-zinc-400">
            Inquiry Recieved <span className="text-indigo-400">Successfully</span>
          </span>
        </div>

        {/* MAIN HEADER */}
        <div className="space-y-4 mb-14">
          <h1 className="text-6xl md:text-9xl font-black tracking-tighter uppercase leading-none">
            Thank <span className="text-transparent bg-clip-text" style={{ backgroundImage: primaryGradient }}>You!</span>
          </h1>
          <p className="text-zinc-500 text-[10px] md:text-base font-black uppercase tracking-[0.1em] md:tracking-[0.4em]">
            We tipically respond within <span className="text-white">15 Minutes</span>
          </p>
        </div>

        {/* PILL BADGES */}
        <div className="flex flex-wrap justify-center gap-2 md:gap-3 mb-16">
          {['Fast Delivery', 'Full Setup', 'UAE Wide', 'Rental & Sale'].map((item) => (
            <div key={item} className="flex items-center gap-2 px-3 md:px-5 py-2.5 rounded-full border border-zinc-800 bg-zinc-900/30 text-[8px] md:text-[10px] font-black tracking-widest text-zinc-300 uppercase">
              <MapPin size={10} className="text-purple-500" />
              {item}
            </div>
          ))}
        </div>

        {/* ACTION BUTTONS */}
        <div className="grid grid-cols-2 gap-2 md:gap-4 max-w-2xl mx-auto">
          <Link to="/" className="block">
            <button 
              style={{ background: primaryGradient }}
              className="w-full h-[50px] md:h-[65px] rounded-xl text-white font-black tracking-tighter md:tracking-widest text-[9px] md:text-xs flex items-center justify-center gap-1 md:gap-3 hover:opacity-90 transition-all"
            >
              <ArrowRight className="w-3 h-3 md:w-[18px] md:h-[18px]" strokeWidth={3} />
              BACK TO HOME
            </button>
          </Link>

          <Link to="/gallery" className="block">
            <button className="w-full h-[50px] md:h-[65px] rounded-xl border border-zinc-800 bg-zinc-900/50 text-white font-black tracking-tighter md:tracking-widest text-[9px] md:text-xs flex items-center justify-center gap-1 md:gap-3 hover:bg-zinc-800 transition-all">
              IMAGE ARCHIVE
            </button>
          </Link>
        </div>

        {/* CONTACT SECTION */}
        <div className="mt-20 pt-10 border-t border-white/5">
          <p className="text-zinc-600 text-[10px] font-black uppercase tracking-[0.5em] mb-10">Need Immediate Asistance?</p>
          
          <div className="flex flex-row items-center justify-center gap-2 md:gap-12">
            {/* Phone Call */}
            <a href={`tel:${phoneNumber.replace(/\s/g, '')}`} className="group flex flex-row items-center gap-1.5 md:flex-col md:gap-3">
              <div className="w-8 h-8 md:w-14 md:h-14 rounded-lg md:rounded-2xl border border-zinc-800 flex items-center justify-center group-hover:border-purple-500 group-hover:bg-purple-500/5 transition-all">
                <Phone size={14} className="text-zinc-500 group-hover:text-purple-400" />
              </div>
              <div className="text-left md:text-center">
                <span className="block text-[7px] md:text-[9px] text-zinc-600 font-black uppercase tracking-widest">Call Now</span>
                <span className="text-[10px] md:text-xl font-black tracking-tighter hover:text-purple-400 transition-colors whitespace-nowrap">{phoneNumber}</span>
              </div>
            </a>

            <div className="h-6 md:h-12 w-px bg-zinc-800/50" />

            {/* WhatsApp */}
            <a href={whatsappLink} target="_blank" rel="noopener noreferrer" className="group flex flex-row items-center gap-1.5 md:flex-col md:gap-3">
              <div className="w-8 h-8 md:w-14 md:h-14 rounded-lg md:rounded-2xl border border-zinc-800 flex items-center justify-center group-hover:border-green-500 group-hover:bg-green-500/5 transition-all">
                <MessageSquare size={14} className="text-zinc-500 group-hover:text-green-400" />
              </div>
              <div className="text-left md:text-center">
                <span className="block text-[7px] md:text-[9px] text-zinc-600 font-black uppercase tracking-widest">Instant Chat</span>
                <span className="text-[10px] md:text-xl font-black tracking-tighter text-green-500 hover:text-green-400 transition-colors uppercase whitespace-nowrap">Whatsapp</span>
              </div>
            </a>
          </div>
        </div>
      </motion.div>

      {/* BACKGROUND DECOR */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 text-[7px] md:text-[10px] font-black text-white/20 uppercase tracking-[0.8em] md:tracking-[1.5em] whitespace-nowrap select-none pointer-events-none">
        Leading Tent Manufacturer UAE
      </div>
    </div>
  );
};

export default Thankyou;